module.exports = __webpack_public_path__ + "static/media/konf-room1.736ec9f6.jpg";